export default __webpack_public_path__ + "static/media/dash-icon-business.9d3a6f74.svg";